import { fetchFamilyGroups } from '@gn-audio/core/api/product-catalogue/fetch-family-groups';
import { IGroup } from '@gn-audio/core/api/product-catalogue/models/group';

interface INonProductSpotScope extends ng.IScope {
  familyId: string;
  replaceProductContent: boolean;
  template: string;
}

/**
 * @deprecated Should be converted into component!
 */
export class NonProductSpotController implements ng.IController {
  public static $inject = ['$scope', '$q'];

  constructor(private $scope: INonProductSpotScope, private $q: ng.IQService) {
    this.$scope.replaceProductContent = false;
    this.$scope.template = '<script>window.replaceMainContent();</script>';

    const familyIdWatcher = this.$scope.$watch('familyId', () => {
      if (this.$scope.familyId === undefined) {
        return;
      }

      familyIdWatcher();
      this.$q
        .when(fetchFamilyGroups(Number(this.$scope.familyId)))
        .then((groups: IGroup[] | null): void => {
          this.$scope.replaceProductContent = (groups || []).length === 0;
        });
    });
  }
}
